import { useHistory } from "react-router";
import {
  Box,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@common-ui/ui";
import { styled } from "@mui/material/styles";
import { format } from "date-fns";
// import ViewListIcon from "@mui/icons-material/ViewList";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import SummarizeIcon from "@mui/icons-material/Summarize";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { getCustomerPlaces, getOrgPlaces } from "../../services";
import { StatusChip, IconButtonComponent } from "./StatusChip";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { scopingHeaderSlice } from "../../reducers/scopingHeaderReducer";
// import { Edit } from "@mui/icons-material";
import { EditWorkEventDialog } from "./EditWorkEventDialog";
import { SummaryResult } from "./SummaryResult";
import { TimeController } from "./TimeController";

export const WorkItemHeader = (props) => {
  // console.log("props", props);
  const dispatch = useDispatch();
  let router = useHistory();
  const [placesParent, setPlacesParent] = useState(undefined);
  const [editWorkEventDialog, setEditWorkEventDialog] = useState(false);
  let row = props?.row;
  // let itemId = props?.row.id;
  let status = row?.status;
  let started = row?.procedure?.status?.procedure?.num_completed !== 0;
  // let completed =
  //   (params.row.procedure?.status?.procedure?.num_completed !== 0 &&
  //     params.row.procedure?.status?.procedure?.num_steps ===
  //       params.row.procedure?.status?.procedure?.num_completed) ||
  let completed = status === "COMPLETED" || status === "CANCELLED";
  let isDraft = status === "DRAFT";
  const StyledBox = styled(Box)({
    display: "inline-flex",
    marginLeft: 5,
    alignItems: "center",
    flexWrap: "wrap",
    marginRight: 5,
  });

  useEffect(() => {
    dispatch(
      scopingHeaderSlice.actions.setScopingHeaderCustomer({
        customer: props?.customer,
      })
    );
    getParent(
      props?.customer,
      props?.places,
      placesParent,
      setPlacesParent,
      dispatch
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.customer, JSON.stringify(props?.places)]);

  let displayComponent;

  if (props?.row?.status === "NOT_STARTED") {
    displayComponent = <NotStartedWorkEventComponent {...props} />;
  } else {
    displayComponent = <StartedWorkEventComponent {...props} />;
  }

  const handleEditWorkEventDialogClose = () => {
    setEditWorkEventDialog(false);
  };

  // const handleEditWorkEventDialogOpen = () => {
  //   setEditWorkEventDialog(true);
  // };

  return !props?.row ? (
    "Loading..."
  ) : (
    <Box
      component="main"
      sx={{
        mb: "24px",
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
      }}
    >
      <Card sx={{ width: "100%", border: 0 }}>
        <CardContent>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <IconButtonComponent status={props?.row?.status} />
            </Grid>

            <Grid item xs>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
              >
                <Grid item>
                  <div>
                    <Typography sx={{ mt: 1 }} variant="h4" fontWeight="700">
                      {props?.row?.id}{" "}
                      {props?.row?.status === "DRAFT" ||
                      props?.row?.status === "COMPLETED" ||
                      props?.row?.status === "CANCELLED" ? (
                        <StatusChip status={props?.row?.status} />
                      ) : (
                        displayComponent
                      )}
                      <Box
                        style={{
                          display: "inline-flex",
                          marginLeft: 15,
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                        sx={{ mr: 3 }}
                      >
                        <Typography fontWeight="700" fontSize="0.7rem">
                          <CorporateFareIcon
                            fontSize="small"
                            style={{ verticalAlign: "middle" }}
                            color="disabled"
                          />{" "}
                          {props?.customer?.name}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography fontWeight="700" fontSize="0.7rem">
                          <LocationOnIcon
                            fontSize="small"
                            style={{ verticalAlign: "middle" }}
                            color="disabled"
                          />{" "}
                          {placesParent && Object.keys(placesParent).length
                            ? placesParent?.name
                            : "--"}
                        </Typography>
                      </Box>
                    </Typography>
                  </div>
                </Grid>
                <Grid item>
                  {/* <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <ViewListIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      <b>Work Items:</b>{" "}
                      {props.workItems ? props.workItems?.length : 0}
                    </Typography>
                  </StyledBox> */}
                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <CalendarMonthIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      Start:{" "}
                      {props.workEvent?.scheduled_start_date !== null
                        ? format(
                            new Date(props.workEvent?.scheduled_start_date),
                            "MM/dd/yyyy"
                          )
                        : ""}
                      {}
                    </Typography>
                  </StyledBox>

                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <CalendarMonthIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      End:{" "}
                      {props.workEvent?.scheduled_end_date !== null
                        ? format(
                            new Date(props.workEvent?.scheduled_end_date),
                            "MM/dd/yyyy"
                          )
                        : ""}
                      {}
                    </Typography>
                  </StyledBox>

                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <PersonIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      Technicians:{" "}
                      {props?.technicians ? props?.technicians?.join(", ") : ""}
                    </Typography>
                  </StyledBox>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  columnGap: "12px",
                }}
              >
                {" "}
                {props?.row ? (
                  <TimeController
                    row={props?.row}
                    isDraft={isDraft}
                    completed={completed}
                    started={started}
                  />
                ) : (
                  ""
                )}
                {props?.row ? (
                  <SummaryResult
                    id={props?.row?.id}
                    work_event={props?.row?.work_event}
                    performing_org={props?.row?.performing_org}
                    row={props?.row}
                  />
                ) : (
                  ""
                )}
              </div>
            </Grid>

            <Grid item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  columnGap: "12px",
                }}
              >
                {/* <Button
                  variant="contained"
                  disabled={props.workEvent?.status !== "DRAFT" ? true : false}
                  onClick={async () => {
                    await publishWorkEvent(props.orgId, props.workEvent?.id);
                    window.location.reload();
                  }}
                >
                  Publish
                </Button> */}

                <IconButton
                  disabled={props.workItems.length === 0}
                  onClick={() => {
                    router.push({
                      pathname: `/work-events/${props?.orgId}/work-event/${props?.row?.id}/download`,
                    });
                  }}
                  size="small"
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                    border: "1px solid grey",
                    borderRadius: 2,
                  }}
                >
                  <Tooltip title="Summary Report">
                    <SummarizeIcon fontSize="small" />
                  </Tooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    console.log("More Buuton");
                  }}
                  size="small"
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                    border: "1px solid grey",
                    borderRadius: 2,
                  }}
                >
                  <MoreHorizIcon fontSize="small" />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <EditWorkEventDialog
        getWorkEvents={props?.getWorkEvents}
        open={editWorkEventDialog}
        handleClose={handleEditWorkEventDialogClose}
        customer={props?.customer}
        place={placesParent}
        orgId={props?.orgId}
        workEvent={props?.row}
      />
    </Box>
  );
};

export const getParent = async (
  item,
  places,
  placesParent,
  setPlacesParent,
  dispatch
) => {
  if (!item) return;
  if (placesParent) return;
  try {
    let placesData = [];
    if (item.system_id) {
      placesData = await getCustomerPlaces(item.org, item.system_id);
    } else {
      placesData = await getOrgPlaces(item.id);
    }

    if (!places.length) {
      setPlacesParent(undefined);
    } else {
      if (!placesParent && places[0]) {
        function getParent(nodes, parent = undefined) {
          if (
            String(nodes.system_id).toLowerCase() ===
            String(places[0]).toLowerCase()
          ) {
            dispatch(
              scopingHeaderSlice.actions.setScopingHeaderPlace({
                places: parent,
              })
            );
            return setPlacesParent(parent);
          } else if (Array.isArray(nodes.child_places)) {
            for (let childNode of nodes.child_places) {
              getParent(childNode, parent);
            }
          } else return;
        }
        for (let i = 0; i < placesData.length; i++) {
          getParent(placesData[i], placesData[i]);
        }
      }
    }
  } catch (error) {
    console.log(error);
    // alert(error);
  }
};

const NotStartedWorkEventComponent = (props) => {
  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} size="small">
      <Select
        disableUnderline={true}
        labelId="work-event-select1-small"
        id="work-event-select1-small"
        value={props?.row?.status}
        onChange={(event) => props.workEventStatusChange(event, props?.row?.id)}
        renderValue={() => {
          return <StatusChip status={props?.row?.status} />;
        }}
      >
        <MenuItem value={"NOT_STARTED"}>Not Started</MenuItem>
        <MenuItem value={"CANCELLED"}>Cancel</MenuItem>
      </Select>
    </FormControl>
  );
};

const StartedWorkEventComponent = (props) => {
  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} size="small">
      <Select
        disableUnderline={true}
        labelId="work-event-select2-small"
        id="work-event-select2-small"
        value={props?.row?.status}
        onChange={(event) => props.workEventStatusChange(event, props?.row?.id)}
        renderValue={() => {
          return <StatusChip status={props?.row?.status} />;
        }}
      >
        <MenuItem value={"IN_PROGRESS"}>In Progress</MenuItem>
        <MenuItem value={"ON_HOLD"}>On Hold</MenuItem>
        <MenuItem value={"PENDING"}>Pending</MenuItem>
        <MenuItem value={"IN_REVIEW"}>In Review</MenuItem>
        <MenuItem
          value={"COMPLETED"}
          disabled={props.totalWorkItemCompleted === 0}
        >
          Completed
        </MenuItem>
      </Select>
    </FormControl>
  );
};
